// ════════════════════════════════════════════════════════════
// Command palette — état d'ouverture (Sprint Shell)
// ════════════════════════════════════════════════════════════
// Store NON persisté (éphémère) : la Topbar (trigger ⌘K) et le
// raccourci clavier global poussent ici ; la CommandPalette
// (montée au root) consomme. Découplé pour éviter un import
// circulaire shell ↔ palette.
// ════════════════════════════════════════════════════════════
import { create } from 'zustand';

interface CommandPaletteState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  open: false,
  setOpen: (open) => {
    set({ open });
  },
  toggle: () => {
    set((s) => ({ open: !s.open }));
  },
}));
